/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ConnectionStatus {
    Before = 'BEFORE',
    After = 'AFTER'
}

export function ConnectionStatusFromJSON(json: any): ConnectionStatus {
    return ConnectionStatusFromJSONTyped(json, false);
}

export function ConnectionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectionStatus {
    return json as ConnectionStatus;
}

export function ConnectionStatusToJSON(value?: ConnectionStatus | null): any {
    return value as any;
}

